var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { PERMISSION_ACTION, USER_PERMISSION_FLAG, VIRTUAL_ENTITY_FLAG } from "../constants";
import { get, isBoolean, isPlainObject } from "lodash";
import { isSelectedMerchantVE } from "./merchantSelectorHelper";
import { hasPermission } from "./permissionsUtils";
function getFeatureFlagFromLS() {
    try {
        var item = localStorage.getItem("featureFlags");
        return item ? JSON.parse(item) : {};
    }
    catch (err) {
        return {};
    }
}
export function haveAccessToFeature(feature) {
    var featureFlags = getFeatureFlagFromLS();
    var hasAccess = get(featureFlags, feature, false);
    return isBoolean(hasAccess) ? hasAccess : false;
}
export function getUserPermissionFlagFromLS() {
    var flags = getFeatureFlagFromLS();
    var userPermissionFlag = get(flags, USER_PERMISSION_FLAG, { enabled: false, config: {}, module: {} });
    return isPlainObject(userPermissionFlag) ? userPermissionFlag : { enabled: false, config: {}, module: {} };
}
/**
 * Returns if the flag is enabled, true if enabled, false if not
 */
export function isPermissionSystemFlagEnabled() {
    return getUserPermissionFlagFromLS().enabled;
}
/**
 * Return specific module name value for given key
 * @param {HasPermissionToViewParams} params - The parameters getModuleNameByKey function
 * @returns {string} - The value of the module name
 */
export function getModuleNameByKey(key) {
    return get(getUserPermissionFlagFromLS().module, key, '');
}
/**
 * Return specific config value for given key
 * @param {HasPermissionToViewParams} params - The parameters getConfigByKey function
 * @returns {string} - The value of the confid
 */
export function getConfigByKey(key) {
    return get(getUserPermissionFlagFromLS().config, key, '');
}
/**
 * Returns all the module names from feature falg
 */
export function getAllModules() {
    return getUserPermissionFlagFromLS().module || {};
}
/**
 * Returns the full config object from feature falg
 */
export function getFullConfig() {
    return getUserPermissionFlagFromLS().config || {};
}
/*
==================================================================
Virtual Entity - required as UP system is not fully migrated yet
==================================================================
*/
export function getVirtualEnitityFlagFromLS() {
    var flags = getFeatureFlagFromLS();
    var virtualEntityFlag = get(flags, VIRTUAL_ENTITY_FLAG, { enabled: false, config: {}, module: {} });
    return isPlainObject(virtualEntityFlag) ? virtualEntityFlag : { enabled: false, enabledTabs: {}, initialTabPath: "" };
}
export function isVirtualEntitySystemEnabled() {
    return getVirtualEnitityFlagFromLS().enabled;
}
export function isTabEnabledForVE(key) {
    if (!isSelectedMerchantVE()) {
        return true;
    }
    return get(getVirtualEnitityFlagFromLS().enabledTabs, key, false) === true;
}
// export function getVEFirstTabToShow(): string {
//   return getVirtualEnitityFlagFromLS().initialTabPath;
// }
var PAGE_CONFIG = {
    dashboard: { module: "homepage", path: "/dashboard" },
    insights: { module: "insight", path: "/insights" },
    finances: { module: "finance", path: "/finances" },
    ump: { module: "marketing", path: "/marketing" },
    menu: { module: "menu", path: "/food/menu" },
    admin: { module: "employee_management/employee", path: "/userprofile/admin" }
};
export function getVEFirstTabToShow() {
    var e_1, _a;
    try {
        for (var _b = __values(Object.entries(PAGE_CONFIG)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), key = _d[0], _e = _d[1], module_1 = _e.module, path = _e.path;
            if (isTabEnabledForVE(key) && hasPermission({ action: PERMISSION_ACTION.GET, module: getModuleNameByKey(module_1) })) {
                return path;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return getVirtualEnitityFlagFromLS().initialTabPath;
}
//# sourceMappingURL=featureFlagHelper.js.map